import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import {
  telegram,
  telegramAction,
  telegramTotal,
  vipEntitiesGet,
  vipEntitiesGraph,
  vipEntitiesTotal,
} from "../../actions/leakedCredentials";
import BasicLineColumn from "../common/apexChart/lineChart";
import Pagination from "../Pagination/Pagination";
import BarchartVip from "../common/barchartvip";
import axios from "axios";
import { API_URL } from "../../utils/constant";
import PieChart from "../../components/common/dashboard12/piechart.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, isValid } from "date-fns";

const datePickerStyles = `
  
`;

const VipEntities = () => {
  const { orgId } = useParams();
  const id = useSelector((state) => {
    return orgId ? orgId : state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
  });
  const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );

  const dispatch = useDispatch();
  const [totalItems, setTotalItems] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const vendorName = sessionStorage.getItem('vendorName');
  const vendorId = sessionStorage.getItem('vendorId');

  const state = useSelector((state) => state?.leakedCredential?.vipEntites?.data?.alerts);
  const auth = useSelector((state) => state?.auth?.user);
  const totalCount = useSelector((state) => state?.leakedCredential?.vipEntites?.data?.totalCount);
  const recordFound = useSelector((state) => state?.leakedCredential?.vipEntitesTotal?.data);
  const oldDnsDetails = useSelector((state) => state.leakedCredential?.vipEntitesGraph?.data);

  // Add search state
  const [search, setSearch] = useState("");
  
  // Add date states
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  
  // Add these new state variables for date picker
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [tempStartDate, setTempStartDate] = useState(null);
  const [tempEndDate, setTempEndDate] = useState(null);
  const [startDateObj, setStartDateObj] = useState(null);
  const [endDateObj, setEndDateObj] = useState(null);

  // Update startDateObj and endDateObj whenever startDate or endDate change
  useEffect(() => {
    if (startDate) {
      setStartDateObj(new Date(startDate));
    }
    if (endDate) {
      setEndDateObj(new Date(endDate));
    }
  }, [startDate, endDate]);

  // Update tempStartDate and tempEndDate whenever startDate or endDate change
  useEffect(() => {
    if (startDate) {
      setTempStartDate(new Date(startDate));
    }
    if (endDate) {
      setTempEndDate(new Date(endDate));
    }
  }, [startDate, endDate]);

  // Add this function to format the displayed date range
  const formatDateRange = () => {
    if (startDate && endDate) {
      return `Selected date: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''} to ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    } else if (startDate) {
      return `From: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''}`;
    } else if (endDate) {
      return `Till: ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    }
    return "Select date range"; // Default placeholder text
  };

  // Add this function to handle applying the selected date range
  const applyDateRange = () => {
    if (tempStartDate) {
      setStartDate(format(tempStartDate, 'yyyy-MM-dd'));
    } else {
      setStartDate('');
    }

    if (tempEndDate) {
      setEndDate(format(tempEndDate, 'yyyy-MM-dd'));
    } else {
      setEndDate('');
    }

    setDatePickerOpen(false);
    setPage(1);
  };

  // Add this function to clear all dates
  const cancelDateSelection = () => {
    setTempStartDate(null);
    setTempEndDate(null);
    setStartDate('');
    setEndDate('');
    setStartDateObj(null);
    setEndDateObj(null);
    setDatePickerOpen(false);
  };

  useEffect(() => {
    if (id) {
      vipEntitiesGet(id, dispatch, page, limit, search, startDate, endDate);
      vipEntitiesTotal(id, dispatch);
      vipEntitiesGraph(id, dispatch);
    }
  }, [id, page, limit, search, startDate, endDate]);

  useEffect(() => {
    setTotalItems(totalCount);
  }, [totalCount]);

  let currentTableData = state || [];

  let clientName = "";

  if (JSON.parse(localStorage.getItem("OrgName"))) {
    if (sessionStorage.getItem('vendorId')) {
      clientName = sessionStorage.getItem('vendorName')
    } else {
      clientName = JSON.parse(localStorage.getItem("OrgName"));
    }
  }

  const downloadFile = async () => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(
        `${API_URL}/organisations/${id}/vip-entities/comprehensive-threat-alerts/excel`,
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${clientName?.replace(/\s+/g, '-')}vip-entities.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
    }
  };

  const series = [
    recordFound?.totalBreaches || 0,
    recordFound?.totalDarkWebMentions || 0,
    recordFound?.totalSocialMediaImpersonations || 0,
    recordFound?.totalPersonalInformationBreaches || 0,
    recordFound?.totalMalwareInfections || 0,
  ];

  const labels = ["Breaches", "Dark Web Mentions", "Social Media Impersonations", "Personal Information", "Malware Infections"];


  return (
    <div className="container-fluid">
      <style>{datePickerStyles}</style>
      <div className="block-header">
        <div className="row clearfix">
          <div className="col-md-6 col-sm-12">
            <h1 className="welcome-text">Vip Entities</h1>
            <nav aria-label="breadcrumb" className="mt-1">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  {vendorId ? (
                    <Link to="/vendor" onClick={() => sessionStorage.clear()}>
                      Forest View
                    </Link>
                  ) : (
                    <Link to="/" className="welcome-textSmall">Home</Link>
                  )}
                </li>
                {vendorName && (
                  <li className="breadcrumb-item active" aria-current="page" style={{ color: "white" }}>
                    {vendorName}
                  </li>
                )}
                <li className="breadcrumb-item active" aria-current="page" style={{ color: "white" }}>
                  VIP Entities
                </li>
              </ol>
              <br />
            </nav>
          </div>
          <div className="col-md-6 col-sm-12 hidden-xs d-flex justify-content-end align-items-center">
            {currentTableData?.length == 0 ? null : (
              <span>
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    downloadFile();
                  }}
                  href="/add-report"
                  className="btn btn-primary mr-1 download-report"
                >
                  Download Details
                </a>
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="row clearfix">
        <div className="col-lg-4 col-md-12">
          <div className="card RecordFoundCard">
            <div className="body" style={{ minHeight: "460px" }}>
              <h6 className="mb-2">Records Found</h6>
              <div className="d-flex mb-3 justify-content-center">
                {series && series?.length > 0 && <PieChart series={series} label={labels} />}
              </div>

              <div className="form-group">
                <label className="d-block" style={{ cursor: 'pointer' }}>
                  <span className="greenShadow"></span>

                  Total Breaches{" "}
                  <span className="float-right">{recordFound?.totalBreaches}</span>
                </label>
              </div>
              <div className="form-group">
                <label className="d-block" style={{ cursor: 'pointer' }}>
                  <span className="yellowShadow"></span>
                  Total Dark Web Mentions{" "}
                  <span className="float-right">{recordFound?.totalDarkWebMentions}</span>
                </label>
              </div>

              <div className="form-group">
                <label className="d-block" style={{ cursor: 'pointer' }}>
                  <span className="redShadow"></span>
                  Total Social Media Impersonations{" "}
                  <span className="float-right">{recordFound?.totalSocialMediaImpersonations}</span>
                </label>
              </div>

              <div className="form-group">
                <label className="d-block" style={{ cursor: 'pointer' }}>
                  <span className="blueShadow"></span>
                  Total Personal Information{" "}
                  <span className="float-right">{recordFound?.totalPersonalInformationBreaches}</span>
                </label>
              </div>

              <div className="form-group">
                <label className="d-block" style={{ cursor: 'pointer' }}>
                  <span className="darkblueShadow"></span>
                  Total Malware Infections{" "}
                  <span className="float-right">{recordFound?.totalMalwareInfections}</span>
                </label>
              </div>
            </div>

          </div>
        </div>
        <div className="col-lg-8 col-md-12 col-sm-12">
          <div className="card">
            <div className="body" style={{ minHeight: "460px" }}>
              <h6 className="welcome-textSmall">Previous scan details</h6>
              {oldDnsDetails && (
                <BarchartVip
                  dates={oldDnsDetails?.dates}
                  total={oldDnsDetails?.scanDetails}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="body">
          <div className="row">
            <div className="col-sm-4 mb-2">
              <div className="searchBoxInput p-0">
                <input
                  class="form-control form-control-sm ml-0 my-1"
                  type="text"
                  placeholder="Search"
                  aria-label="Search"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setPage(1);
                  }}
                />
              </div>
            </div>
            <div className="col-sm-4 mb-2">
              <div className="date-picker-container">
                <div className="date-range-input">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Select date range"
                    value={formatDateRange()}
                    onClick={() => setDatePickerOpen(true)}
                    readOnly
                  />
                  <span className="calendar-icon">
                    <i className="fa fa-calendar" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="row clearfix">
            <div className="col-lg-12 col-md-12">
              <div className="table-responsive">
                <table className="table table-custom spacing5 mb-0">
                  <thead>
                    <tr>
                      <th>Type</th>
                      <th>Email</th>
                      <th>Description</th>
                      <th>Username</th>
                      <th>Link</th>
                      <th>Address</th>
                      <th>Phone Number</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentTableData.map((row, index) => {
                      // Helper function to render address
                      const renderAddress = (address) => {
                        if (!address) return "N/A";
                        if (typeof address === 'string') return address;
                        if (typeof address === 'object') {
                          const parts = [];
                          if (address.home) parts.push(`Home: ${address.home}`);
                          if (address.work) parts.push(`Work: ${address.work}`);
                          return parts.length > 0 ? parts.join(', ') : "N/A";
                        }
                        return "N/A";
                      };

                      // Helper function to render contact number
                      const renderContactNumber = (contactNumber) => {
                        if (!contactNumber) return "N/A";
                        if (typeof contactNumber === 'string') return contactNumber;
                        if (typeof contactNumber === 'object') {
                          const parts = [];
                          if (contactNumber.home) parts.push(`Home: ${contactNumber.home}`);
                          if (contactNumber.work) parts.push(`Work: ${contactNumber.work}`);
                          return parts.length > 0 ? parts.join(', ') : "N/A";
                        }
                        return "N/A";
                      };

                      return (
                        <tr key={index}>
                          <td>{row?.type || "N/A"}</td>
                          <td>{row?.email || "N/A"}</td>
                          <td style={{ maxWidth: "200px", wordWrap: "break-word", whiteSpace: "normal" }} title={row?.description || "N/A"}>
                            {row?.description || "N/A"}
                          </td>
                          <td>{row?.username || "N/A"}</td>
                          <td>{row?.link || "N/A"}</td>
                          <td>{renderAddress(row?.address)}</td>
                          <td>{renderContactNumber(row?.contact_number)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-between align-content-center">
                <div className="dataTables_paginate">
                  {totalItems > 10 && (
                    <Pagination
                      className="pagination-bar"
                      currentPage={page}
                      totalCount={totalItems}
                      pageSize={10}
                      onPageChange={(newPage) => setPage(newPage)}
                    />
                  )}
                </div>
                {totalItems > 10 && (
                  <select
                    value={limit}
                    onChange={(e) => {
                      setLimit(e.target.value)
                    }}
                    className="form-control limitSelectBox"
                  >
                    <option value={10}>10 per page</option>
                    <option value={25}>25 per page</option>
                    <option value={50}>50 per page</option>
                    <option value={100}>100 per page</option>
                  </select>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Add the date picker overlay */}
      {datePickerOpen && (
        <div className="date-range-overlay" onClick={() => setDatePickerOpen(false)}>
          <div className="date-range-picker-popup" onClick={(e) => e.stopPropagation()}>
            <div className="date-range-picker-header">
              {tempStartDate && tempEndDate
                ? `Selected date: ${format(tempStartDate, 'MM/dd/yyyy')} to ${format(tempEndDate, 'MM/dd/yyyy')}`
                : "Select date range"}
            </div>
            <div className="date-range-calendars">
              <div>
                <h6>From</h6>
                <DatePicker
                  selected={tempStartDate}
                  onChange={(date) => {
                    setTempStartDate(date);
                    if (tempEndDate && date > tempEndDate) {
                      setTempEndDate(null);
                    }
                  }}
                  selectsStart
                  startDate={tempStartDate}
                  endDate={tempEndDate}
                  inline
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>
              <div>
                <h6>To</h6>
                <DatePicker
                  selected={tempEndDate}
                  onChange={(date) => setTempEndDate(date)}
                  selectsEnd
                  startDate={tempStartDate}
                  endDate={tempEndDate}
                  minDate={tempStartDate}
                  inline
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>
            </div>
            <div className="date-range-actions">
              <button
                className="date-range-apply"
                onClick={applyDateRange}
              >
                Apply Filter
              </button>
              <button
                className="date-range-cancel"
                onClick={cancelDateSelection}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VipEntities;
